const TERMS_CONTACT_EMAIL = "support@playdailywars.com";

export function TermsContactEmail() {
  return (
    <a
      href={`mailto:${TERMS_CONTACT_EMAIL}`}
      className="text-primary underline underline-offset-4 hover:text-foreground"
    >
      {TERMS_CONTACT_EMAIL}
    </a>
  );
}
